import React, { useState, useEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import heatmap from 'highcharts/modules/heatmap';
import exporting from 'highcharts/modules/exporting';
import exportingOffline from 'highcharts/modules/offline-exporting';
import { DimensionNames } from '../../../../Constants/DimensionNames';
import { generateChartOptions } from './TrendsChartUtils';
import { Badge } from '@mds/mds-reactjs-library'

heatmap(Highcharts);
exporting(Highcharts);
exportingOffline(Highcharts);

const MarginTrendsByProducts = ({ Chart, ChartData, ChartRef, SelectedAttributeNamesByDimension }) => {
  const [chartOptions, setChartOptions] = useState(null);

  useEffect(() => {

    if (!ChartData) return;

    const chartTitle = Chart.title;
    const chartSubtitle = `basis points (bps), ${SelectedAttributeNamesByDimension[DimensionNames.ProductID][0]}, ${SelectedAttributeNamesByDimension[DimensionNames.CountryID][0]}`;
    const customTooltipConfig = {
      headerFormat: '<b>{category}</b><br/>',
      pointFormat: '{series.name}: <b>{point.y}</b>',
    };

    const options = generateChartOptions(ChartData, SelectedAttributeNamesByDimension, 'line', chartTitle, chartSubtitle, undefined, customTooltipConfig);
    setChartOptions(options);
  }, [ChartData, SelectedAttributeNamesByDimension]);

  return (
    <div className="highchart">
      {ChartData && chartOptions ? (
        <HighchartsReact highcharts={Highcharts} options={chartOptions} ref={ChartRef} />
      ) : (
        <div style={{ position: 'relative' }}>
          <img
            style={{ opacity: 0.3, width: '100%' }}
            src={Chart?.preview || (Chart && `data:${Chart?.thumbnailMimetype};base64,${Chart?.thumbnail}`)}
            alt={Chart?.title || ""}
          />
          <Badge style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '120px',
            height: '40px',
            fontSize: '16px',
            transform: 'translate(-50%, -50%) rotate(0deg)',
            background: '#B3B3B3',
            color: '#333'
          }}>PREVIEW</Badge>
        </div>
      )}
    </div>
  );
};

export default MarginTrendsByProducts;